export default __webpack_public_path__ + "static/media/Ramin.1f4f408f.jpg";